<template>
  <div style="min-height: 100px;" class="leftTree">
    <el-tree
      ref="moveTree"
      draggable
      :allow-drag="allowDrop"
      @node-click="getAllTask"
      @node-expand="nodeExpand"
      @node-collapse="nodeCollapse"
      @node-contextmenu="rightClickLeft"
      :props="props"
      :data="treeData"
      :default-expanded-keys="teamExpandedKeys"
      node-key="NODEID"
    >
      <span
        class="custom-tree-node"
        @dragenter="dragEnter(data, $event)"
        @drop="drop(data, $event)"
        slot-scope="{ node, data }"
      >
        <el-tooltip
          class="item"
          effect="dark"
          :value="data.NODEID==dragId"
          :hide-after="1000"
          content="不可拖入"
          :manual="true"
          placement="top"
        >
          <span>
            <svg class="icon alSvgIcon" aria-hidden="true">
              <use :xlink:href="'#'+getIcon(data)" />
            </svg>
            &nbsp;{{ node.label }}
          </span>
        </el-tooltip>
      </span>
    </el-tree>
    <contextMenu
      ref="contextMenu"
      :contextMenu="contextmenuRow"
      :isShowOpenButton="false"
      :multipleSelection="multipleSelection"
    ></contextMenu>
  </div>
</template>

<script>
import contextMenu from "@/views/task/common/contextmenuGroup.vue";
import folderApi from "@/api/modules/basicData/folder";
import { getParent, listToTree } from "@/api/modules/basicData/commonData";
import Linq from "linq";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      contextmenuRow: {},
      multipleSelection: [],
      keys: ["-2"],
      props: {
        label: "NODENAME",
        children: "children",
        isLeaf: "isLeaf"
      }
    };
    expanded: false;
  },
  components: {
    contextMenu
  },
  computed: {
    ...mapState({
      taskGroupTree: state => state.folder.taskGroupTree,
      Person: state => state.folder.Person,
      treeData: state => state.folder.teamTreeData,
      treeList: state => state.folder.teamTreeList,
      teamExpandedKeys: state => state.folder.teamExpandedKeys,
      dragId: state => state.task.dragId
    })
  },
  watch: {
    treeData(val) {
      let tree = this.$refs.moveTree.getNode("-2");
    }
  },
  methods: {
    getIcon(row) {
      return row.RELATIONTYPE == 'PUB_GROUP' ? "icon-zu1" : 'icon-zul';
    },
    rightClickLeft(ev, data, node, val) {
      this.contextmenuRow = data;
      this.multipleSelection = [data];

      event.preventDefault();
      const postition = {
        top: event.clientY,
        left: event.clientX
      };
      this.$refs.contextMenu.Show(postition);
    },
    nodeExpand(data, node, current) {
      //展开
      this.keys.push(data.NODEID);
      console.log("nodeExpandData", data);
      console.log("nodeExpandNode", node);
      console.log("nodeExpandCurrent", current);
      this.$store.commit("setExpandedKeys", this.keys);
    },
    nodeCollapse(data, node, current) {
      //关闭
      var index = this.keys.indexOf(data.NODEID);
      if (index > -1) {
        this.keys.splice(index, 1);
      }
      // this.keys.remove(data.NODEID);
      this.$store.commit("setExpandedKeys", this.keys);
    },
    loadNode(node, resolve) {
      console.log("loadNode1", node);
      console.log("loadNode2", resolve);
      if (node.level === 0) {
        return resolve([
          // {
          //   NODENAME: "常用",
          //   NODEID: null,
          //   IsRoot: true,
          //   isLeaf: true,
          //   state: 0,
          //   pid:'',
          //   Children: null
          // },
          // {
          //   NODENAME: "共享任务组",
          //   NODEID: null,
          //   IsRoot: true,
          //   state: 1,
          //   PermissionType:1,
          //   Children: []
          // },
          // {
          //   NODENAME: "个人任务组",
          //   NODEID: null,
          //   IsRoot: true,
          //   state: 2,
          //   PermissionType:0,
          //   Children: []
          // },
          {
            NODENAME: "团队任务组",
            NODEID: "-2",
            IsRoot: true,
            state: 3,
            pid: "",
            PermissionType: 2,
            Children: []
          }
        ]);
      }

      if (node.level === 1) {
        // if (node.state == 0) {
        // }
        this.$store.commit("setPermissionType", node.data.PermissionType);

        console.log("node", node);
        switch (node.data.state) {
          case 1:
            // resolve(this.taskGroupTree);
            this.GetTaskTreePathList(
              {
                IdPath: "",
                NodeName: "",
                CreateTime1: "",
                CreateTime2: "",
                TaskType: "",
                IsRoot: true,
                PermissionType: 1
              },
              resolve
            );
            break;
          case 2:
            this.GetTaskTreePathList(
              {
                IdPath: "",
                NodeName: "",
                CreateTime1: "",
                CreateTime2: "",
                TaskType: "",
                IsRoot: true,
                PermissionType: 0
              },
              resolve
            );
            break;
          case 3:
            this.GetTaskTreePathList(
              {
                IdPath: "",
                NodeName: "",
                CreateTime1: "",
                CreateTime2: "",
                TaskType: "",
                IsRoot: true,
                PermissionType: 2
              },
              resolve
            );
            break;
        }
      }

      if (node.level > 1) {
        if (node.state == 0) {
        } else {
          this.GetTaskTreePathList(
            {
              NodeId: node.data.NODEID,
              IsRoot: false
            },
            resolve
          );
        }
      }
    },
    allowDrop(draggingNode, dropNode, type) {
      return false;
    },
    getAllTask(data) {
      this.$refs.contextMenu.Hide();
      console.log("节点点击:", data);
      this.$store.commit("changeCurTask", {});
      data.type = 1;
      this.rClickLeft = false;
      // let tree = this.$refs.moveTree.getNode('-2');
      // console.log('getNode',this.$refs.moveTree.getNode('-2'));
      // console.log('getNode1',data);

      this.$emit("getAllTask", data);
      if (data.IsRoot) {
        this.$store.commit("setFolderPath");
      } else {
        console.log("treeList", this.treeList);
        // let tree = listToTree('RELATIONID','PRELATIONID',this.treeList)
        console.log("NODEID", data.NODEID);
        let arr = this.getParent(this.treeList, data.VirtualId);
        console.log("arr", arr);
        // arr.push(data);
        this.$store.commit("setTreeFolderPath", arr);
        this.$store.commit("setParentInfo", data);
        // this.$store.commit("setFolderPath", data);
      }
    },
    getParent(tree, id) {
      var arrRes = [];
      if (tree.length == 0) {
        if (!!id) {
          arrRes.unshift(tree);
        }
        return arrRes;
      }
      let rev = (data, nodeId) => {
        for (var i = 0, length = data.length; i < length; i++) {
          let node = data[i];
          if (node.VirtualId == nodeId) {
            arrRes.unshift(node);
            rev(tree, node.PvirtualId);
            break;
          } else {
            if (!!node.children) {
              rev(node.children, nodeId);
            }
          }
        }
        return arrRes;
      };
      arrRes = rev(tree, id);
      return arrRes;
    },
    drop(data, $event) {
      console.log("drop", data);
      let draggableRow = Object.assign(
        {},
        this.$store.state.template.draggableRow
      );
      let row = Object.keys(this.$store.state.template.draggableRow);
      console.log("draggableRow", row);
      this.$store.state.template.draggableRow = {};

      if (this.dragId) {
        this.$message({
          type: "info",
          message: "不可拖入"
        });
        return false;
      }

      let childrens = Object.keys(data.children);
      if (childrens.length > 0) {
        let list = data.children.filter(
          item => item.NODEID === draggableRow.NODEID
        );
        if (list.length > 0) {
          this.$message({
            type: "info",
            message: "已经包含不能进行添加"
          });
          return false;
        }
      }

      // console.log('draggableRow',draggableRow)
      // console.log('字段值',draggableRow[this.filedID])
      if (row.length > 0) {
        draggableRow.PNODEID = data.NODEID;
        draggableRow.PNODENAME = data.NODENAME;
        draggableRow.PNODETYPE = data.NODETYPE;
        draggableRow.CREATETIME = new Date(draggableRow.CREATETIME);
        (draggableRow.PRELATIONID = data.RELATIONID),
          (draggableRow.PRELATIONTYPE = data.RELATIONTYPE),
          (draggableRow.RELATIONCREATETIME = new Date(
            draggableRow.RELATIONCREATETIME
          ));

        this.$store.dispatch("AddTaskTreePath", [draggableRow]);
      }

      this.$store.commit("setDragId", "");
    },
    dragEnter(data, $event) {
      console.log("dragEnter", data.NODEID);
      console.log("draggableRow", this.$store.state.template.draggableRow);
      if (
        this.$store.state.template.draggableRow.RELATIONTYPE === "PUB_GROUP" ||
        this.$store.state.template.draggableRow.NODEID === data.NODEID
      ) {
        this.$store.commit("setDragId", data.NODEID);
      } else {
        this.$store.commit("setDragId", "");
      }
    },
    GetTaskTreePathList(paras, resolve) {
      paras.Person = this.Person;
      folderApi.GetTaskTreePathList(paras).then(res => {
        if (res && res.length > 0) {
          res = Linq.from(res)
            .orderByDescending(item => item.CREATETIME)
            .toArray();
          if (paras.PermissionType !== 2) {
            res = res.filter(item => item.NODETYPE == 3);
          }
          res.forEach(item => {
            item.isLeaf = item.CHILDRENCOUNT == 0;
            // item.pid=paras.NodeId
            item.PermissionType = paras.PermissionType;
            this.treeList.push(item);
          });
          return resolve(res);
        } else {
          return resolve([]);
        }
      });
    },
    async GetMyTaskTreePath() {
      let item = await folderApi.GetMyTaskTreePath(this.Person).then(res => {
        if (!res) {
          return [];
        } else {
          return res.find(item => item.NODENAME == "团队").children;
        }
      });

      this.treeList = item;
      this.treeData = [
        {
          NODENAME: "常用",
          NODEID: null,
          IsRoot: true,
          isLeaf: true,
          state: 0,
          pid: "",
          children: null
        },
        {
          NODENAME: "团队任务组",
          NODEID: "-2",
          IsRoot: true,
          state: 3,
          pid: "",
          PermissionType: 2,
          children: item
        }
      ];

      console.log("treeData", this.treeData);
    }
  },
  mounted() {
    this.$store.dispatch("GetMyTaskTreePath");
  }
};
</script>

<style scoped>
.leftTree >>> .el-tree {
  background-color: #eef2f5;
  color: #5c5c5c;
  letter-spacing: 0.6px;
  font-size: 18px;
}
.leftTree >>> .el-tree-node>.el-tree-node__children{
  overflow: inherit;
}

.custom-tree-node {
  width: 100%;
}
.nowrap {
  width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.icon {
  font-size: 16px;
}

.alSvgIcon {
  width: 18px;
  height: 18px;
  fill: currentColor;
  overflow: hidden;
}
</style>